module.exports = __webpack_public_path__ + "static/media/jorge_tadao_matsushima.c132d55f.jpg";